import { Component, OnInit } from '@angular/core';
import { User } from '../../../shared/classes/user';
import { ContactService } from '../../services/contact.service';
import { UserService } from '../../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-add-users-page',
  templateUrl: './add-users-page.component.html',
  styleUrls: ['./add-users-page.component.scss']
})
export class AddUsersPageComponent implements OnInit {
  users: User[] = [];
  edit: boolean[] = [];
  editing: boolean[] = [];
  user: User = <User>{};
  sub: any;
  orgId: number;
  adding: boolean;
  error: string;
  errMsg: string;
  openCreateUser: boolean;
  fnFocus: boolean = false;
  lnFocus: boolean = false;
  phoneFocus: boolean = false;
  emailFocus: boolean = false;
  posFocus: boolean = false;
  perFocus: boolean = false;
  reqFocus: boolean = false;
  focus: any[] = [];
  openPermBubble: boolean = false;
  permBubbleOpen: boolean[] = [];
  isAdmin: boolean = false;

  constructor(
    private ContactService: ContactService,
    private route: ActivatedRoute,
    private titleService: Title,
    private UserService: UserService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getUsers();
    this.titleService.setTitle('Add Users');

    this.UserService.getUserInfo()
      .subscribe(user => {
        console.log(user)
        let u: any = JSON.parse(user.user);
        this.isAdmin = u.admin;
      }, err => {
        console.log(err)
        if (err.status == 401) {
          localStorage.clear();
          this.router.navigate(['/']);
        }
      })
  }

  getUsers() {
    let users = [];
    let currentUser: any = <any>{};

    this.sub = this.route.params.subscribe(params => {
      this.orgId = +params['orgId'];
      let errId: number = +params['errId'];
      if (errId == 1) {
        this.errMsg = 'You cannot go to next step until current step is finished.'
      }
      new Promise<void>((resolve, reject) => {
        this.ContactService.getContacts(this.orgId)
          .subscribe(contacts => {
            users = JSON.parse(contacts.contacts);
            this.users = JSON.parse(contacts.contacts);
            this.edit = this.users.map((u) => {
              return false;
            })
            this.editing = JSON.parse(JSON.stringify(this.edit));
            this.focus = this.users.map((u) => {
              return {
                fnFocus: false,
                lnFocus: false,
                phoneFocus: false,
                emailFocus: false,
                posFocus: false,
                perFocus: false,
                reqFocus: false
              };
            })

            this.permBubbleOpen = this.users.map(u => {
              return false;
            })
            console.log(users)
            resolve();
          }, err => {
            console.log(err)
            if (err.status == 401) {
              localStorage.clear();
              this.router.navigate(['/']);
            }
            reject();
          })
      })
        .then(() => {
          return new Promise<void>((resolve, reject) => {
            this.UserService.getUserInfo()
              .subscribe(user => {
                console.log(user)
                currentUser = JSON.parse(user.user);
                resolve();
              }, err => {
                console.log(err)
                if (err.status == 401) {
                  localStorage.clear();
                  this.router.navigate(['/']);
                }
                reject();
              })
          })
        })
        .then(() => {
          if (users.length == 0) {
            this.user = currentUser;
            this.user.phone = currentUser.phone_number;
          }
        })
    });
  }


  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  createUser(userForm: NgForm) {
    this.adding = true;
    this.errMsg = '';
    if (userForm.invalid) {
      return;
    }
    this.ContactService.addContact(this.orgId, this.user)
      .subscribe(contacts => {
        this.adding = false;
        this.user = <User>{};
        userForm.reset();
        this.getUsers();
        this.openCreateUser = false;
        if(!this.isAdmin) window.analytics.track("Self-Signup User Added", {OrgId: this.orgId});
      }, err => {
        console.log(err)
        this.errMsg = JSON.parse(JSON.parse(err._body).flash)[0][1];
        if(!this.isAdmin) window.analytics.track("Self-Signup User Add Failed", {OrgId: this.orgId, reason: this.errMsg});
      })
  }

  editUser(index: number) {
    this.edit[index] = true;
  }

  removeUser(id: number) {
    this.ContactService.deleteContact(this.orgId, id)
      .subscribe(contacts => {
        this.getUsers();
      })
  }

  completeEdit(id: number, index: number, user: User, userForm: NgForm) {
    this.editing[index] = true;
    if (userForm.valid) {
      this.ContactService.editContact(this.orgId, id, user)
        .subscribe(contacts => {
          this.editing[index] = false;
          if(!this.isAdmin) window.analytics.track("Self-Signup User Edited", {OrgId: this.orgId});
          this.getUsers();
        }, err => {
          console.log(err)
          if(!this.isAdmin) window.analytics.track("Self-Signup User Edit Failed", {OrgId: this.orgId, reason: JSON.parse(JSON.parse(err._body).flash)[0][1]});
          if (err.status == 401) {
            localStorage.clear();
            this.router.navigate(['/']);
          }
        })
    }


  }

  cancelEdit(index: number) {
    this.getUsers();
  }

  showError() {
    this.error = 'Please complete this form before proceeding.';
  }

  onClickedOutside(e: any) {
    console.log('Clicked outside:', e);
    if (e.target.className != 'fa fa-question-circle-o') {
      this.openPermBubble = false;
      this.permBubbleOpen = this.permBubbleOpen.map(p => { return false; });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/onboarding/components/add-users-page/add-users-page.component.ts